import { showHeaderOverlay, hideHeaderOverlay, showOverlay } from '../functions/overlay';
import { checkResolution } from '../functions/helpers';
import '../ui/tabs';

const navigation = document.querySelector('.js-navigation')

const handleClickOutside = (event) => {
    if (checkResolution('md;lg')) {
        if (!navigation.contains(event.target)) {
            navigation.closeAllTabs()
            hideHeaderOverlay('nav')
            document.removeEventListener('click', handleClickOutside)
        }
    }
}

const onNavTabOpen = () => {
    if (checkResolution('md;lg')) {
        showHeaderOverlay('nav')
        document.addEventListener('click', handleClickOutside)
    }
}

const onNavTabClose = () => {
    if (checkResolution('md;lg')) {
        hideHeaderOverlay('nav')
        document.removeEventListener('click', handleClickOutside)
    }
}

if (navigation) {
    navigation.addEventListener('rTab.after.closeAllTabs', onNavTabClose)
    navigation.addEventListener('rTab.after.closeTab', onNavTabClose)
    navigation.addEventListener('rTab.after.openTab', onNavTabOpen)
}

const aside = {
    trigger: document.querySelector('.js-aside-trigger'),
    target: document.querySelector('.js-header-navigation'),
    toggle() {
        if (this.trigger.classList.contains('is-active')) {
            this.close()
        } else {
            this.open()
        }
    },
    open() {
        this.trigger.classList.add('is-active')
        this.target.classList.add('is-active')
        showHeaderOverlay('nav-aside')
        document.addEventListener('click', this.handleClickOutside.bind(this))
    },
    close() {
        this.trigger.classList.remove('is-active')
        this.target.classList.remove('is-active')
        hideHeaderOverlay('nav-aside')
        document.removeEventListener('click', this.handleClickOutside.bind(this))
    },
    handleClickOutside(event) {
        if (!checkResolution('md;lg') && !this.target.contains(event.target) && !this.trigger.contains(event.target)) {
            this.close()
        }
    }
}

if (aside.trigger) {
    aside.trigger.addEventListener('click', event => {
        aside.toggle()
    })
}